module.exports = __webpack_public_path__ + "ecce3cf619adb4c3160f2283ff40bab4.png";